import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2022十大重庆科技创新年度人物评选';
const baseUrl = '20220422KJCX';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
  ],
};

export default route;
